module.exports = __webpack_public_path__ + "assets/img/homebj.9f32e8b8.png";